import { Box, Tooltip, Typography } from "@mui/joy";
import React from "react";

export function FauxTable({children, sx = {}}) {
    return (
        <Box sx={{
            display: 'grid',
            rowGap: 0,
            columnGap: 1,
            alignItems: 'center',
            gridTemplateColumns: 'min-content auto',
            ...sx
        }}>
            {children}
        </Box>
    )
}

export function FauxTableRow({title, tooltipTitle = null, breakTitle = true, children, ...restProps}) {
    return (<>
        <Tooltip title={tooltipTitle}>
        <Box sx={{textAlign: 'right'}}>
            <Typography
                fontSize={'sm'}
                fontWeight={'bold'}
                sx={{
                    whiteSpace: breakTitle ? 'unset' : 'nowrap',
                    ...restProps?.titleSx ?? {},
                }}
            >
                {title}
            </Typography>
        </Box>
        </Tooltip>
        <Tooltip title={tooltipTitle}>
        <Box>
            {children}
        </Box>
        </Tooltip>
    </>)
}
